export const formatDateMsDsY = (date: Date | string | number) => {
  const d = new Date(date);
  const month = d.getMonth() > 8 ? d.getMonth() + 1 : `0${d.getMonth() + 1}`;
  const day = d.getDate() > 9 ? d.getDate() : `0${d.getDate()}`;
  return `${month}/${day}/${d.getFullYear()}`;
};
